import React,{ createContext, useContext, useState } from "react";
import useInitialState from "../hooks/useInitialState";

export const PresentacionContext = createContext();


export const PresentacionProvider = ({children}) => {
    const initialState = useInitialState()
    return <PresentacionContext.Provider value={initialState}>
        {children}
    </PresentacionContext.Provider>
}

export const usePresentacionContext = () => {
    
    const context = useContext(PresentacionContext)
    if(context === undefined){
        throw new Error('PresentacionContext must be used within a PresentacionProvider')
    }
    return context
}